import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { FieldDataType } from '../../../../../sic-lib/enums/FieldDataType';
import { ConversationGridFiltersActions } from '../../../../../sic-lib/reducers/conversationGridFiltersReducer';

const operandsLists: Record<string, string[]> = {
    default: [
        'is',
        'is not',
        'in',
        'starts with',
        'ends with',
        'contains',
        /*'is empty',*/ 'is not empty',
    ],
    range: ['is', 'is not', 'between', /*'is empty',*/ 'is not empty'],
    includes: ['includes', 'excludes' /*'is empty',*/],
};

interface Props {
    fieldId: number;
    fieldType: FieldDataType;
    operand: string;
    formDispatch: React.Dispatch<ConversationGridFiltersActions>;
}

export default function SelectFilterOperand({ fieldId, fieldType, operand, formDispatch }: Props) {
    const [options, setOptions] = React.useState<string>('default');

    React.useEffect(() => {
        switch (fieldType) {
            case FieldDataType.date:
            case FieldDataType.float:
            case FieldDataType.integer:
                setOptions('range');
                break;
            case FieldDataType.tags:
            case FieldDataType.users:
            case FieldDataType.enum:
                setOptions('includes');
                break;
            default:
                setOptions('default');
        }
    }, [fieldType]);

    const handleChangeOperand = (event: React.ChangeEvent<HTMLInputElement>) => {
        formDispatch({
            type: 'MODIFY_FORM_FILTER',
            fieldId: fieldId,
            condition: {
                operand: event.target.value,
            },
        });
    };

    return (
        <TextField
            id={`operand_select_${fieldId}`}
            select
            label="Select Operand"
            name="operand"
            value={operand}
            onChange={handleChangeOperand}
            variant="outlined"
            size="small"
            fullWidth
        >
            {operandsLists[options].map(opt => (
                <MenuItem key={`select_operand_item_${opt}`} value={opt}>
                    {opt}
                </MenuItem>
            ))}
        </TextField>
    );
}
